import { useEffect } from 'react';
import { type Editor as SlateEditor } from 'slate';

import { isHtmlContent } from 'src/lib/html';

import { replaceSlateEditorHtml, replaceSlateEditorText } from './transforms';

export const useMergeForcedTextValue = (editor: SlateEditor, forcedTextValue: string): void => {
  useEffect(() => {
    if (forcedTextValue == null || !editor) {
      return;
    }

    if (isHtmlContent(forcedTextValue)) {
      replaceSlateEditorHtml(editor, forcedTextValue);
    } else {
      replaceSlateEditorText(editor, forcedTextValue);
    }
  }, [forcedTextValue, editor]);
};
